export default "__VITE_ASSET__DY1CgF$z__"